export const SERVICE_TYPES = {
  ACCESSIBILITY: 'accessibility',
  SERVICE: 'service'
};
